/**
 * @ngdoc Controller
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .controller('ConfiguringModalController', ConfiguringModalController);

    /* @ngInject */
    function ConfiguringModalController($scope, close) {
        return {
            close: close
        };
    }

})();
